
// This will be used for generic functionality like adding labels, admin actions etc.
import { ContentState, convertFromRaw, EditorState } from "draft-js";
import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css';
import { RiPencilFill } from "react-icons/ri";


// Actual rendered component is in its own type
export default function ComponentContainer({ component, error, children, onEdit, access }) {

    const convertRTE = (initialContent) => {
        if (initialContent) {
            try {
                if (typeof initialContent === 'string' && initialContent.startsWith('{')) {
                    initialContent = JSON.parse(initialContent); // For Old format need double parsing
                }
                return EditorState.createWithContent(convertFromRaw(initialContent));
            } catch {
                try {
                    return EditorState.createWithContent(ContentState.createFromText(initialContent));
                } catch {
                    console.warn("Failed to parse initial content for AdminRTE, using empty state.");
                    return EditorState.createEmpty();
                }
            }
        }
        return EditorState.createEmpty();
    };

    return (
        <>
            <div className={`d-flex ${component.componentType !== 'Display Text' ? 'my-2' : ''}`}>
                {component.componentType !== 'Display Text' && <label className="flex-grow-1">{component && typeof component.question === "string" && component.question}</label>}
                {/* {component.componentType === 'Display Text' && <Editor readonly editorState={convertRTE(component.question)} />} */}
                {access.includes('Admin') && <div
                    onMouseDown={e => {
                        e.stopPropagation();
                        e.preventDefault();
                    }}
                    onClick={e => {
                        e.preventDefault();
                        e.stopPropagation();
                        if (onEdit) onEdit(component);
                    }}
                ><RiPencilFill /></div>}
            </div>
            {children}
            {error && <small className='text-danger'>{error}</small>}
        </>
    );
};
